import { all, takeLatest, put, select, call } from 'redux-saga/effects';
import { STAT_BAR_SCOPES } from '../../common/constants/StatBarConstants';
import {
  fetchStatBarConfig,
  saveStatBarConfig,
} from '../routines/statBarRoutines';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';

function* fetchStatBarConfigSaga(action) {
  try {
    const { level, scope = STAT_BAR_SCOPES.ENTITY_LIST } = action.payload;
    const { userId } = yield select((state) => state.currentUser.user);

    const url = `${envConfig.APIG_URL}core/user-settings/${userId}/stat-bar/${scope}/${level}`;
    const response = yield call(request, url);
    const config = response.data;

    yield put(fetchStatBarConfig.success({ level, scope, config }));
  } catch (error) {
    yield put(fetchStatBarConfig.failure({ error }));
  }
}

function* saveStatBarConfigSaga(action) {
  try {
    const {
      level,
      scope = STAT_BAR_SCOPES.ENTITY_LIST,
      config,
      onSuccess,
      globalPresetType = false,
    } = action.payload;
    const { userId } = yield select((state) => state.currentUser.user);

    let url = `${envConfig.APIG_URL}core/user-settings/${userId}/stat-bar/${scope}/${level}`;

    if (globalPresetType) {
      url += `?globalPresetType=${globalPresetType}`;
    }

    const requestConfig = {
      method: 'POST',
      payload: config,
    };

    yield call(request, url, requestConfig);

    yield put(
      saveStatBarConfig.success({
        level,
        scope,
        config,
        successMessage: globalPresetType
          ? SUCCESS_MESSAGES.GLOBAL_PRESET
          : SUCCESS_MESSAGES.ADD_EDIT_STAT_BAR,
      })
    );

    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    yield put(saveStatBarConfig.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchStatBarConfig.TRIGGER, fetchStatBarConfigSaga),
    takeLatest(saveStatBarConfig.TRIGGER, saveStatBarConfigSaga),
  ]);
}
